<template>
    <div class="dashboard-form">
        <h1>Add Tags</h1>
        <form @submit.prevent="submitHandler">
            <div class="form-group" :class="{invalid: $v.formdata.name.$error}">
                <label>Name</label>
                <input type="text" v-model.trim="$v.formdata.name.$model" class="form-control" placeholder="Name">
                <div v-if="$v.formdata.name.$error">
                    <p class="error_label_red" v-if="!$v.formdata.name.required">This input is required.</p>
                </div> 
            </div>
             <div class="form-group">
                <label>Slug</label>
                <slug-input v-model.trim="$v.formdata.name.$model" @change="onSlugChange($event)" class="form-control" placeholder="Slug"></slug-input>
                <div v-if="$v.formdata.slug.$error">
                <p class="error_label_red" v-if="!$v.formdata.slug.required">This input is required.</p>
                </div>
            </div>
            <div class="form-group">
                <label>Description</label>
                <textarea v-model.trim="$v.formdata.description.$model" class="form-control" placeholder="Description"></textarea>
            </div>
            <button type="submit" class="btn btn-primary">Add Tag</button>
        </form>
        <div v-if="addtag" class="post_succesfull">Tag has been added successfully.</div>
    </div>
</template>

<script>
/* eslint-disable */
import { required,  maxLength, minLength } from 'vuelidate/lib/validators';

export default {
    data() {
        return{
            error : false,
            formdata:{
                name:'',
                slug:'',
                description:''
            }
        }
    },
    validations:{
        formdata:{
            name:{
                required
            },
            slug:{
                required
            },
            description:{}
        }
    },
    computed:{
        addtag(){
            let status = this.$store.getters['admin/addTagStatus'];
                if(status){
                    this.clearTag();
                }
            return status;
        }
    },
    methods:{
        submitHandler(){
            this.$v.formdata.$touch();
            if(!this.$v.$invalid){
                if(this.formdata.content === ''){
                    this.error = true;
                } else {
                    this.dialog = true;
                    this.addTag();
                }
            } else {
                this.error = true;
            }
        },
        addTag(){
            this.$store.dispatch('admin/addTag', this.formdata)
        },
        clearTag(){
            this.$v.$reset();
            this.formdata ={
                name:'',
                slug:'',
                description:''
            }
        },
        onSlugChange(event) {
            this.formdata.slug = event;
        },
    }
}
</script>